export const API_VERSION = 'v1.0'
const HOST_URL = `testempire-website.empirecinemas.com`
const LIVEBASEURL = `https://replicabrij-api-v1.empirecinemas.com`

let DEVBASEURL = `http://localhost:3800`
let IMG_URL = `https://replicabrij-api-v1.empirecinemas.com`

export const ImageS3URL = `https://d2h4kll8mltez0.cloudfront.net/`
DEVBASEURL = `https://replicabrij-api-v1.empirecinemas.com`

export const IMG_BASEURL = IMG_URL

export const BASEURL_BRIJ =
  window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL

export const Empire = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdlN2IzZWFiLTJlOTEtNDkzOS05ZjBmLTdmMzQyODJmZTZjYSIsImlhdCI6MTcyNTYwNjYwOX0.pILOcTmclBlDOEBzzdgTMURHANw-rRKpIp5-CAcvZnw`

export const TOKEN = Empire

export const PublicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtfZ+d9wSyfS8qwRufUo2
GRMGA/NrFBcsUyWeZ8aM6LCldIoUx/xdFu4lEvUdZv10AqbEutZAhTY4X4V4J/2D
bVehnJALbQkrstbM+1vx5gbXH6AlXGCuCrsS34b6ius60YZCohscfMLTleI4MeKc
/CmeERJ5oVdDK2iQxewjOFJn7glM1B8VWm8Uoi4/TvfzZvVM9oAJpb+snJzHF5Zv
7whRtV7FHoLUP268u279d/YeYAnYAxol+LmPUVQ0QgBdGO7KvqeJA0fuYZXdUwi1
WPcFt8G4E6Znv3lT+AUIf97QiNbWvlsFA75gCXTDTu0tqiQvnIYl5R1dppyVQAsS
MwIDAQAB
-----END PUBLIC KEY-----`;



// WEBPACK FOOTER //
// ./src/config/index.js